// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var Browser__Runtime$SmartcutsMacros = require("./browser/Browser__Runtime.bs.js");

function MakeResponderTypesWithDeccoSupport(ResponseDescriptor) {
  var result__encode = function (v) {
    return Decco.resultToJson(ResponseDescriptor.res_encode, ResponseDescriptor.resError_encode, v);
  };
  var result__decode = function (v) {
    return Decco.resultFromJson(ResponseDescriptor.res_decode, ResponseDescriptor.resError_decode, v);
  };
  var respondToSender_encode = function (_fn) {
    return "respondToSender";
  };
  var respondToSender_decode = function (encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
      if (str === "respondToSender") {
        return {
                TAG: /* Ok */0,
                _0: (function (_result) {
                    
                  })
              };
      } else {
        return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
      }
    } else {
      return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
  };
  return {
          result__encode: result__encode,
          result__decode: result__decode,
          respondToSender_encode: respondToSender_encode,
          respondToSender_decode: respondToSender_decode
        };
}

function MakeResponderTypesWithDeccoSupportWithoutDot(ResponseDescriptor) {
  var result__encode = function (v) {
    return Decco.resultToJson(ResponseDescriptor.res_encode, ResponseDescriptor.resError_encode, v);
  };
  var result__decode = function (v) {
    return Decco.resultFromJson(ResponseDescriptor.res_decode, ResponseDescriptor.resError_decode, v);
  };
  var respondToSender_encode = function (_fn) {
    return "respondToSender";
  };
  var respondToSender_decode = function (encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
      if (str === "respondToSender") {
        return {
                TAG: /* Ok */0,
                _0: (function (_result) {
                    
                  })
              };
      } else {
        return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
      }
    } else {
      return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
  };
  return {
          result__encode: result__encode,
          result__decode: result__decode,
          respondToSender_encode: respondToSender_encode,
          respondToSender_decode: respondToSender_decode
        };
}

function MakeExtensionMessageSender(MessageAndResponseTransform) {
  var message_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_encode, v);
  };
  var message_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_decode, v);
  };
  var response_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var response_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var responseError_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.responseError_encode, v);
  };
  var responseError_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.responseError_decode, v);
  };
  var res_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var res_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var resError_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.responseError_encode, v);
  };
  var resError_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.responseError_decode, v);
  };
  var result__encode = function (v) {
    return Decco.resultToJson(res_encode, resError_encode, v);
  };
  var result__decode = function (v) {
    return Decco.resultFromJson(res_decode, resError_decode, v);
  };
  var respondToSender_encode = function (_fn) {
    return "respondToSender";
  };
  var respondToSender_decode = function (encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
      if (str === "respondToSender") {
        return {
                TAG: /* Ok */0,
                _0: (function (_result) {
                    
                  })
              };
      } else {
        return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
      }
    } else {
      return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
  };
  var allResponse_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.allResponse_encode, v);
  };
  var allResponse_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.allResponse_decode, v);
  };
  var allResult_encode = function (v) {
    return Decco.resultToJson(allResponse_encode, responseError_encode, v);
  };
  var allResult_decode = function (v) {
    return Decco.resultFromJson(allResponse_decode, responseError_decode, v);
  };
  var makeRespondToBg = function (allRespondToSender, result) {
    var tmp;
    tmp = result.TAG === /* Ok */0 ? ({
          TAG: /* Ok */0,
          _0: Curry._1(MessageAndResponseTransform.wrapResponseAsAllResponse, result._0)
        }) : ({
          TAG: /* Error */1,
          _0: result._0
        });
    return allRespondToSender(tmp);
  };
  var encodeAndSendMessageToMainFrameAndMaybeAllFrames = function (tabId, message) {
    return browser.tabs.sendMessage(tabId, Curry._1(MessageAndResponseTransform.allMessage_encode, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message))).then(function (json) {
                var result = Decco.resultFromJson(allResponse_decode, responseError_decode, json);
                if (result.TAG === /* Ok */0) {
                  var result$1 = result._0;
                  var tmp;
                  tmp = result$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, result$1._0)
                      }) : ({
                        TAG: /* Error */1,
                        _0: result$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = result._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from tab - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  var encodeAndSendMessageToFrame = function (tabId, frameId, message) {
    return browser.tabs.sendMessage(tabId, Curry._1(MessageAndResponseTransform.allMessage_encode, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message)), {
                  frameId: frameId
                }).then(function (json) {
                var result = Decco.resultFromJson(allResponse_decode, responseError_decode, json);
                if (result.TAG === /* Ok */0) {
                  var result$1 = result._0;
                  var tmp;
                  tmp = result$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, result$1._0)
                      }) : ({
                        TAG: /* Error */1,
                        _0: result$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = result._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from tab - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  var encodeAndSendMessageInternal = function (message) {
    return browser.tabs.sendMessage(Curry._1(MessageAndResponseTransform.allMessage_encode, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message))).then(function (json) {
                var result = Decco.resultFromJson(allResponse_decode, responseError_decode, json);
                if (result.TAG === /* Ok */0) {
                  var result$1 = result._0;
                  var tmp;
                  tmp = result$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, result$1._0)
                      }) : ({
                        TAG: /* Error */1,
                        _0: result$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = result._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from tab - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  return {
          message_encode: message_encode,
          message_decode: message_decode,
          response_encode: response_encode,
          response_decode: response_decode,
          responseError_encode: responseError_encode,
          responseError_decode: responseError_decode,
          result__encode: result__encode,
          result__decode: result__decode,
          respondToSender_encode: respondToSender_encode,
          respondToSender_decode: respondToSender_decode,
          allResult_encode: allResult_encode,
          allResult_decode: allResult_decode,
          makeRespondToBg: makeRespondToBg,
          encodeAndSendMessageToMainFrameAndMaybeAllFrames: encodeAndSendMessageToMainFrameAndMaybeAllFrames,
          encodeAndSendMessageToFrame: encodeAndSendMessageToFrame,
          encodeAndSendMessageInternal: encodeAndSendMessageInternal
        };
}

function MakeTabMessageSender(MessageAndResponseTransform) {
  var message_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_encode, v);
  };
  var message_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_decode, v);
  };
  var response_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var response_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var responseError_encode = Decco.stringToJson;
  var responseError_decode = Decco.stringFromJson;
  var res_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var res_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var resError_encode = Decco.stringToJson;
  var resError_decode = Decco.stringFromJson;
  var result__encode = function (v) {
    return Decco.resultToJson(res_encode, resError_encode, v);
  };
  var result__decode = function (v) {
    return Decco.resultFromJson(res_decode, resError_decode, v);
  };
  var respondToSender_encode = function (_fn) {
    return "respondToSender";
  };
  var respondToSender_decode = function (encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
      if (str === "respondToSender") {
        return {
                TAG: /* Ok */0,
                _0: (function (_result) {
                    
                  })
              };
      } else {
        return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
      }
    } else {
      return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
  };
  var allResponse_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.allResponse_decode, v);
  };
  var makeRespondToBg = function (allRespondToSender, result) {
    if (result.TAG === /* Ok */0) {
      return allRespondToSender({
                  TAG: /* Ok */0,
                  _0: Curry._1(MessageAndResponseTransform.wrapResponseAsAllResponse, result._0)
                });
    } else {
      return allRespondToSender({
                  TAG: /* Error */1,
                  _0: result._0
                });
    }
  };
  var encodeAndSendMessage = function (message) {
    return Browser__Runtime$SmartcutsMacros.sendMessageToExtension(Curry._1(MessageAndResponseTransform.allMessage_encode, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message))).then(function (json) {
                var result = Decco.resultFromJson(allResponse_decode, Decco.stringFromJson, json);
                if (result.TAG === /* Ok */0) {
                  var result$1 = result._0;
                  var tmp;
                  tmp = result$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, result$1._0)
                      }) : ({
                        TAG: /* Error */1,
                        _0: result$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = result._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from extension - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  var encodeAndSendMessageToExtensionId = function (extensionId, message) {
    return browser.runtime.sendMessage(extensionId, Curry._1(MessageAndResponseTransform.allMessage_encode, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message))).then(function (json) {
                var result = Decco.resultFromJson(allResponse_decode, Decco.stringFromJson, json);
                if (result.TAG === /* Ok */0) {
                  var result$1 = result._0;
                  var tmp;
                  tmp = result$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, result$1._0)
                      }) : ({
                        TAG: /* Error */1,
                        _0: result$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = result._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from extension - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  return {
          message_encode: message_encode,
          message_decode: message_decode,
          response_encode: response_encode,
          response_decode: response_decode,
          responseError_encode: responseError_encode,
          responseError_decode: responseError_decode,
          result__encode: result__encode,
          result__decode: result__decode,
          respondToSender_encode: respondToSender_encode,
          respondToSender_decode: respondToSender_decode,
          makeRespondToBg: makeRespondToBg,
          encodeAndSendMessage: encodeAndSendMessage,
          encodeAndSendMessageToExtensionId: encodeAndSendMessageToExtensionId
        };
}

function MakeWrappedTabMessageSender(MessageAndResponseTransform, WrappedMessageAndResponse) {
  var message_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_encode, v);
  };
  var message_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.message_decode, v);
  };
  var response_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var response_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var responseError_encode = Decco.stringToJson;
  var responseError_decode = Decco.stringFromJson;
  var res_encode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_encode, v);
  };
  var res_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.response_decode, v);
  };
  var resError_encode = Decco.stringToJson;
  var resError_decode = Decco.stringFromJson;
  var result__encode = function (v) {
    return Decco.resultToJson(res_encode, resError_encode, v);
  };
  var result__decode = function (v) {
    return Decco.resultFromJson(res_decode, resError_decode, v);
  };
  var respondToSender_encode = function (_fn) {
    return "respondToSender";
  };
  var respondToSender_decode = function (encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
      if (str === "respondToSender") {
        return {
                TAG: /* Ok */0,
                _0: (function (_result) {
                    
                  })
              };
      } else {
        return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
      }
    } else {
      return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
    }
  };
  var allResponse_decode = function (v) {
    return Curry._1(MessageAndResponseTransform.allResponse_decode, v);
  };
  var makeRespondToBg = function (allRespondToSender, result) {
    var tmp;
    tmp = result.TAG === /* Ok */0 ? ({
          TAG: /* Ok */0,
          _0: Curry._1(MessageAndResponseTransform.wrapResponseAsAllResponse, result._0)
        }) : ({
          TAG: /* Error */1,
          _0: result._0
        });
    return allRespondToSender(tmp);
  };
  var encodeAndSendMessage = function (message) {
    return Browser__Runtime$SmartcutsMacros.sendMessageToExtension(Curry._2(WrappedMessageAndResponse.message_encode, MessageAndResponseTransform.allMessage_encode, Curry._1(WrappedMessageAndResponse.wrapMessage, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message)))).then(function (json) {
                var wrappedMessageAndResponseResult = Curry._2(WrappedMessageAndResponse.result_decode, allResponse_decode, json);
                if (wrappedMessageAndResponseResult.TAG === /* Ok */0) {
                  var wrappedMessageAndResponseResult$1 = wrappedMessageAndResponseResult._0;
                  var tmp;
                  tmp = wrappedMessageAndResponseResult$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, Curry._1(WrappedMessageAndResponse.unwrapResponse, wrappedMessageAndResponseResult$1._0))
                      }) : ({
                        TAG: /* Error */1,
                        _0: wrappedMessageAndResponseResult$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = wrappedMessageAndResponseResult._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from extension - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  var encodeAndSendMessageToExtensionId = function (extensionId, message) {
    return browser.runtime.sendMessage(extensionId, Curry._2(WrappedMessageAndResponse.message_encode, MessageAndResponseTransform.allMessage_encode, Curry._1(WrappedMessageAndResponse.wrapMessage, Curry._1(MessageAndResponseTransform.wrapMessageAsAllMessage, message)))).then(function (json) {
                var wrappedMessageAndResponseResult = Curry._2(WrappedMessageAndResponse.result_decode, allResponse_decode, json);
                if (wrappedMessageAndResponseResult.TAG === /* Ok */0) {
                  var wrappedMessageAndResponseResult$1 = wrappedMessageAndResponseResult._0;
                  var tmp;
                  tmp = wrappedMessageAndResponseResult$1.TAG === /* Ok */0 ? ({
                        TAG: /* Ok */0,
                        _0: Curry._1(MessageAndResponseTransform.unwrapAllResponseAsResponse, Curry._1(WrappedMessageAndResponse.unwrapResponse, wrappedMessageAndResponseResult$1._0))
                      }) : ({
                        TAG: /* Error */1,
                        _0: wrappedMessageAndResponseResult$1._0
                      });
                  return Promise.resolve(tmp);
                }
                var deccoDecodeError = wrappedMessageAndResponseResult._0;
                console.error(deccoDecodeError);
                return Util$SmartcutsMacros.logAndRaiseJsError("Error decoding response from extension - path=" + (deccoDecodeError.path + ("; message=" + (deccoDecodeError.message + ("; value=" + (JSON.stringify(deccoDecodeError.value) + ("; in response to message=" + JSON.stringify(Curry._1(MessageAndResponseTransform.message_encode, message)))))))));
              });
  };
  return {
          message_encode: message_encode,
          message_decode: message_decode,
          response_encode: response_encode,
          response_decode: response_decode,
          responseError_encode: responseError_encode,
          responseError_decode: responseError_decode,
          result__encode: result__encode,
          result__decode: result__decode,
          respondToSender_encode: respondToSender_encode,
          respondToSender_decode: respondToSender_decode,
          makeRespondToBg: makeRespondToBg,
          encodeAndSendMessage: encodeAndSendMessage,
          encodeAndSendMessageToExtensionId: encodeAndSendMessageToExtensionId
        };
}

exports.MakeResponderTypesWithDeccoSupport = MakeResponderTypesWithDeccoSupport;
exports.MakeResponderTypesWithDeccoSupportWithoutDot = MakeResponderTypesWithDeccoSupportWithoutDot;
exports.MakeExtensionMessageSender = MakeExtensionMessageSender;
exports.MakeTabMessageSender = MakeTabMessageSender;
exports.MakeWrappedTabMessageSender = MakeWrappedTabMessageSender;
/* Util-SmartcutsMacros Not a pure module */
